import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Cart Drawer Web Component
 */
class CartDrawerComponent extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  #handleCartAdd = () => {
    if (this.hasAttribute('auto-open')) {
      this.showDialog();
    }
  };

  open() {
    this.showDialog();

    // Close cart drawer when installments CTA is clicked
    customElements.whenDefined('shopify-payment-terms').then(() => {
      const installmentsContent = document
        .querySelector('shopify-payment-terms')
        ?.shadowRoot;
      const cta = installmentsContent?.querySelector('#shopify-installments-cta');
      cta?.addEventListener('click', this.closeDialog, { once: true });
    });
  }

  close() {
    this.closeDialog();
  }
}

if (!customElements.get('cart-drawer-component')) {
  customElements.define('cart-drawer-component', CartDrawerComponent);
}

/* -------------------------------------------------------
   Gift Message sync (safe, isolated, won't break the drawer)
---------------------------------------------------------*/
(function () {
  // Debounce helper
  const debounce = (fn, ms = 350) => {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn(...args), ms);
    };
  };

  // Push attribute to cart
  const pushGiftMessage = (value) => {
    try {
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'Gift Message': value || '' },
        }),
      }).catch(() => {});
    } catch (e) {
      // ignore
    }
  };

  const sync = () => {
    const field = document.querySelector('#DrawerGiftMessage');
    if (!field) return;

    // Sync initial value (useful when reopening drawer)
    pushGiftMessage(field.value);

    // On input (debounced) + on change (immediate)
    const onInput = debounce(() => pushGiftMessage(field.value), 400);
    const onChange = () => pushGiftMessage(field.value);

    field.removeEventListener('input', onInput);
    field.removeEventListener('change', onChange);
    field.addEventListener('input', onInput);
    field.addEventListener('change', onChange);
  };

  // Run now…
  document.addEventListener('DOMContentLoaded', sync);
  // …and again whenever the drawer DOM يتحدث
  document.addEventListener('click', (e) => {
    // عند فتح السلة أو تغيير الكوانتيتي قد يُعاد رسم المحتوى
    const btn = e.target && (e.target.closest('[data-testid="cart-drawer-trigger"]') || e.target.closest('button'));
    // نحاول كل مرة بعد تفاعلات شائعة
    setTimeout(sync, 300);
  });
})();